import React, { useState, useRef, useEffect } from 'react';
import '../assets/styles/SearchableDropdown.css';

const SearchableDropdown = ({ 
  options, 
  value, 
  onChange, 
  placeholder, 
  allOptionLabel = "Todas",
  className = "" 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  // Atualizar opções filtradas quando options ou searchTerm mudarem
  useEffect(() => {
    if (!searchTerm) {
      setFilteredOptions(options);
    } else {
      const filtered = options.filter(option =>
        option.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredOptions(filtered);
    }
  }, [options, searchTerm]);

  // Fechar dropdown quando clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Focar no input quando abrir
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setSearchTerm('');
    }
  };

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
    setSearchTerm('');
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && filteredOptions.length > 0) {
      handleOptionClick(filteredOptions[0]);
    } else if (e.key === 'Escape') {
      setIsOpen(false);
      setSearchTerm('');
    }
  };

  const displayValue = value === 'Todas' ? allOptionLabel : value;

  return (
    <div className={`searchable-dropdown ${className}`} ref={dropdownRef}>
      <div className="dropdown-header" onClick={handleToggle}>
        <span className="dropdown-value">{displayValue}</span>
        <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </div>
      
      {isOpen && (
        <div className="dropdown-content">
          <div className="search-container">
            <input
              ref={inputRef}
              type="text"
              className="search-input"
              placeholder={`Pesquisar ${placeholder.toLowerCase()}...`}
              value={searchTerm}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
          </div>
          
          <div className="options-container">
            {/* Opção "Todas" sempre visível no topo */}
            <div
              className={`dropdown-option ${value === 'Todas' ? 'selected' : ''}`}
              onClick={() => handleOptionClick('Todas')}
            >
              {allOptionLabel}
            </div>
            
            {/* Opções filtradas */}
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => (
                <div
                  key={index}
                  className={`dropdown-option ${value === option ? 'selected' : ''}`}
                  onClick={() => handleOptionClick(option)}
                >
                  {option}
                </div>
              ))
            ) : searchTerm ? (
              <div className="no-options">
                Nenhum resultado encontrado para "{searchTerm}"
              </div>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;
